<div class="bg-black text-white rounded p-2 wm-6">
  <div class="mb-0" [innerHTML]="html | unsafeHtml"></div>
</div>
